/**
 * Enumération définissant les colonnes affichables pour le tableau des PEI
 */
enum COLUMN_INDISPONIBILITE_TEMPORAIRE {
  MOTIF = "MOTIF",
  DATE_DEBUT = "DATE_DEBUT",
  DATE_FIN = "DATE_FIN",
  STATUT = "STATUT",
  AUTO_DISPONIBLE = "AUTO_DISPONIBLE",
  AUTO_INDISPONIBLE = "AUTO_INDISPONIBLE",
  MAIL_AVANT = "MAIL_AVANT",
  MAIL_APRES = "MAIL_APRES",
  LIST_PEI = "LIST_PEI",
  DESCRIPTION = "DESCRIPTION",
  COMMUNE = "COMMUNE",
}
export default COLUMN_INDISPONIBILITE_TEMPORAIRE;
